<script lang="ts">
  interface Option {
    value: string;
    label: string;
    disabled?: boolean;
  }
  interface Props {
    id: string;
    label: string;
    value: string;
    options: Option[];
    disabled?: boolean;
    error?: string | undefined;
    hideLabel?: boolean;
    onchange?: (value: string) => void;
  }
  let {
    id,
    label,
    value = $bindable(),
    options,
    disabled = false,
    error,
    hideLabel = false,
    onchange
  }: Props = $props();
  const errorId = $derived(`${id}-error`);
</script>

<div class="select-wrap">
  <label for={id} class:sr-only={hideLabel}>{label}</label>
  <div class="select-shell" class:invalid={!!error}>
    <select
      {id}
      bind:value
      {disabled}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={error ? errorId : undefined}
      onchange={(e) => onchange?.((e.currentTarget as HTMLSelectElement).value)}
    >
      {#each options as option (option.value)}
        <option value={option.value} disabled={option.disabled}>{option.label}</option>
      {/each}
    </select>
    <svg viewBox="0 0 16 16" aria-hidden="true" class="chev"><path d="M4 6l4 4 4-4" stroke="currentColor" fill="none" stroke-width="1.5" /></svg>
  </div>
  {#if error}<p id={errorId} class="error" role="alert">{error}</p>{/if}
</div>

<style>
  .select-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  label {
    font-size: 13px;
    font-weight: 600;
    color: var(--muted);
  }
  .select-shell {
    position: relative;
    display: flex;
    align-items: center;
  }
  select {
    appearance: none;
    width: 100%;
    background: var(--bg-2);
    border: 1px solid var(--line-soft);
    color: var(--text);
    border-radius: var(--radius-btn);
    padding: 11px 36px 11px 14px;
    font-family: inherit;
    font-size: 15px;
    min-height: 42px;
    cursor: pointer;
    transition: border-color var(--dur-3) var(--ease), box-shadow var(--dur-3) var(--ease);
  }
  /* Site .field:focus. The --ring-soft halo is decoration; the :focus-visible
   * outline from app.css remains the keyboard focus indicator. */
  select:focus {
    border-color: var(--accent);
    box-shadow: var(--ring-soft);
  }
  select:focus:not(:focus-visible) {
    outline: none;
  }
  .select-shell.invalid select {
    border-color: var(--err-line);
  }
  .chev {
    position: absolute;
    right: 12px;
    width: 16px;
    height: 16px;
    color: var(--muted);
    pointer-events: none;
  }
  .error {
    font-size: 12.5px;
    color: var(--err-text);
    margin: 0;
  }
</style>
